// const isLocalhost = Boolean(
//   window.location.hostname === "localhost" ||
//     // [::1] is the IPv6 localhost address.
//     window.location.hostname === "[::1]" ||
//     // 127.0.0.0/8 are considered localhost for IPv4.
//     window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
// );

type Config = {
  onSuccess: (registration: ServiceWorkerRegistration) => void;
  onUpdate: (registration: ServiceWorkerRegistration) => void;
  statusUpdate: (newStatus: string) => void;
};

export async function register(config: Config) {
  if ("serviceWorker" in navigator) {
    // The URL constructor is available in all browsers that support SW.
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // Our service worker won't work if PUBLIC_URL is on a different origin
      // from what our page is served on. This might happen if a CDN is used to
      // serve assets; see https://github.com/facebook/create-react-app/issues/2374
      config.statusUpdate("InvalidOrigin");
      return;
    }

    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
    registerValidSW(swUrl, config);
    await navigator.serviceWorker.ready;
    console.log("This web app is being served cache-first by a service worker.");

    navigator.serviceWorker.addEventListener("controllerchange", () => {
      console.log("service Worker controller change");
      window.location.reload();
    });

    const sw = await navigator.serviceWorker.ready;
    config.statusUpdate(`${Boolean(sw.active) ? "Active": "Inactive"} ${Boolean(sw.waiting) ? "Waiting": "No update"}`);

    // });
  }
}

async function registerValidSW(swUrl: string, config: Config) {
  try {
    const registration = await navigator.serviceWorker.register(swUrl);

    if (registration.waiting) {
      console.log("Pending service worker update ready");
      if (config.onUpdate) {
        config.onUpdate(registration);
        config.statusUpdate("Pending update");
      }
    }

    registration.addEventListener("updatefound", () => {
      const installingWorker = registration.installing;
      if (installingWorker == null) {
        console.log("Update found, but no installing worker");
        config.statusUpdate("No Installer");
        return;
      }
      installingWorker.addEventListener("statechange", () => {
        console.log("StateChange", installingWorker.state);
        if (installingWorker.state === "installed") {
          if (navigator.serviceWorker.controller) {
            // At this point, the updated precached content has been fetched,
            // but the previous service worker will still serve the older
            // content until all client tabs are closed.
            console.log(
              "New content is available and will be used when all tabs for this page are closed. See https://cra.link/PWA."
            );

            // Execute callback
            config.onUpdate(registration);
            config.statusUpdate("New version available")
          } else {
            // At this point, everything has been precached.
            // It's the perfect time to display a
            // "Content is cached for offline use." message.
            console.log("Content is cached for offline use.");
            config.statusUpdate("Initial install")

            // Execute callback
            config.onSuccess(registration);
          }
        }
      });
      installingWorker.addEventListener("error", (evt) =>{
        config.statusUpdate("Error: " + evt.message)
      })
    });
    return registration;
  } catch (error) {
    console.error("Error during service worker registration:", error);
    config.statusUpdate("Error during service worker registration: " + error)
    return undefined;
  }
}

// async function checkValidServiceWorker(swUrl: string, config?: Config) {
//   // Check if the service worker can be found. If it can't reload the page.
//   try {
//     const response = await fetch(swUrl, { headers: { "Service-Worker": "script" } });

//     // Ensure service worker exists, and that we really are getting a JS file.
//     const contentType = response.headers.get("content-type");
//     if (response.status === 404 || (contentType != null && contentType.indexOf("javascript") === -1)) {
//       // No service worker found. Probably a different app. Reload the page.
//       const registration = await navigator.serviceWorker.ready;
//       await registration.unregister();
//       window.location.reload();
//     } else {
//       // Service worker found. Proceed as normal.
//       registerValidSW(swUrl, config);
//     }
//   } catch (ex) {
//     console.log("No internet connection found. App is running in offline mode.");
//   }
// }

// export async function unregister() {
//   if ("serviceWorker" in navigator) {
//     try {
//       const registration = await navigator.serviceWorker.ready;
//       registration.unregister();
//     } catch (error: any) {
//       console.error(error.message);
//     }
//   }
// }
